import Cookies from 'js-cookie'

const TokenKey = 't'
const TmpAccTokenKey = 'TmpAccToken';

function getMainDomainName() {
  try {
    let names = document.domain.split('.');
    if(names.length >= 2) {
      names.splice(0, 1);
      return '.' + names.join('.');
    }
  } catch(e) {
    //
  }
}

function getTokenCookieOption() {
  let option;
  let mainDomain = getMainDomainName();
  if(mainDomain) {
    option = { domain: mainDomain };
  }
  return option;
}

export function getToken() {
  const token = sessionStorage.getItem('portal_token');
  return token || Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, getTokenCookieOption());
}

export function removeToken() {
  Cookies.remove(TokenKey);
  return Cookies.remove(TokenKey, getTokenCookieOption());
}

export const checkTmpAccToken = function(_uri) {
  try {
    let searchStr = _uri || window.location.search;
    if(searchStr && searchStr.length > 1) {
      let _index = searchStr.indexOf('?');
      if(_index >= 0) {
        searchStr = searchStr.substr(_index + 1);
      }
      const params = {};
      const lets = searchStr.split('&');
      for(let i = 0; i < lets.length; i++) {
        const pair = lets[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      const _token = params['tac'];
      if(_token) {
        Cookies.set(TmpAccTokenKey, _token)
      }
    }
  } catch(e) {
    console.log(e);
  }
}

export const getTmpAccToken = function() {
  return Cookies.get(TmpAccTokenKey);
}

export const clearTmpAccToken = function() {
  return Cookies.remove(TmpAccTokenKey);
}
